(function () {
  const ROOT_SELECTOR = [
    '.hashiaid-emergent',
    '.gutsupport-emergent',
    '.gutsupport-pm-emergent',
    '.testbalance-emergent',
    '.omega-emergent',
    '.hormonesupport-emergent',
    '.digestion-emergent',
    '.acv-emergent',
    '.prepro-emergent',
    '.collagen-chocolate-emergent',
    '.collagen-vanilla-emergent',
    '.collagen-unflavored-emergent'
  ].join(',');

  const AXOS_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0515/6998/3677/t/26/assets/axos-logo-trimmed.png?v=1781810207';

  const mediaHydrationPromises = new WeakMap();

  function getImageSource(image) {
    return image.currentSrc || image.getAttribute('src') || image.src || '';
  }

  function normalizeImageUrl(url) {
    if (!url) return '';
    const value = String(url).trim();
    if (!value) return '';
    if (value.indexOf('//') === 0) return window.location.protocol + value;
    return value;
  }

  function imageKey(url) {
    return normalizeImageUrl(url)
      .replace(/^https?:/, '')
      .replace(/([?&])width=\d+(&|$)/, '$1')
      .replace(/[?&]$/, '');
  }

  function setImageSource(image, src) {
    const normalized = normalizeImageUrl(src);
    if (!image || !normalized) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = normalized;
  }

  function getProductHandle() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const productIndex = parts.indexOf('products');
    return productIndex >= 0 ? parts[productIndex + 1] || '' : '';
  }

  function getGalleryElements(root) {
    const thumbs = Array.from(root.querySelectorAll('img[alt="thumb"]'));
    if (!thumbs.length) return {};

    const thumbGrid = thumbs[0].closest('.grid');
    const frame = thumbGrid && thumbGrid.previousElementSibling;
    if (!frame) return {};

    const mainImage = Array.from(frame.querySelectorAll('img')).find((image) => image.alt !== 'thumb');
    const controls = Array.from(frame.querySelectorAll('button.absolute'));
    const previousButton = controls.find((button) => String(button.className).includes('left-3')) || controls[0];
    const nextButton = controls.find((button) => String(button.className).includes('right-3')) || controls[1];
    const counter = Array.from(frame.querySelectorAll('div')).find((node) => /^\d+\s*\/\s*\d+$/.test(node.textContent.trim()));

    return { thumbs, thumbGrid, frame, mainImage, previousButton, nextButton, counter };
  }

  function selectProductImages(images) {
    const unique = [];
    const seen = new Set();

    images.map(normalizeImageUrl).filter(Boolean).forEach((src) => {
      const key = imageKey(src);
      if (seen.has(key)) return;
      seen.add(key);
      unique.push(src);
    });

    const selected = unique.slice(0, 5);
    const factsImage = unique.find((src) => /supplement|facts|\bsf\b|-sf|_sf|supp[-_ ]?facts/i.test(src)) ||
      (unique.length === 6 ? unique[unique.length - 1] : '');
    if (factsImage && !selected.some((src) => imageKey(src) === imageKey(factsImage))) {
      if (selected.length >= 5) {
        selected[selected.length - 1] = factsImage;
      } else {
        selected.push(factsImage);
      }
    }

    return selected;
  }

  async function hydrateGalleryFromProduct(root) {
    if (!root) return;
    if (mediaHydrationPromises.has(root)) return mediaHydrationPromises.get(root);

    const handle = getProductHandle();
    if (!handle) return;

    const gallery = getGalleryElements(root);
    if (!gallery.thumbGrid || !gallery.mainImage) return;

    root.dataset.axosMediaHydrationStarted = 'true';

    const hydrationPromise = (async () => {
      try {
      const response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      });
      if (!response.ok) throw new Error('Product media unavailable');

      const product = await response.json();
      const images = selectProductImages(product.images || []);
      if (images.length < 2) return;

      const firstThumbButton = gallery.thumbs[0].closest('button') || gallery.thumbs[0];
      const template = firstThumbButton.cloneNode(true);
      gallery.thumbGrid.innerHTML = '';
      gallery.thumbGrid.style.gridTemplateColumns = 'repeat(' + images.length + ', minmax(0, 1fr))';

      images.forEach((src, index) => {
        const button = template.cloneNode(true);
        const image = button.querySelector('img') || document.createElement('img');
        image.alt = 'thumb';
        setImageSource(image, src);
        if (!image.parentNode) button.appendChild(image);

        button.classList.toggle('border-[#5094F4]', index === 0);
        button.classList.toggle('border-transparent', index !== 0);
        button.classList.toggle('opacity-70', index !== 0);
        button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
        gallery.thumbGrid.appendChild(button);
      });

      setImageSource(gallery.mainImage, images[0]);
      if (gallery.counter) gallery.counter.textContent = '1/' + images.length;
      root.dataset.axosMediaHydrated = 'true';
      delete root.dataset.axosGalleryReady;
      } catch (error) {
      root.dataset.axosMediaHydrated = 'false';
      } finally {
        root.dataset.axosMediaHydrationFinished = 'true';
      }
    })();

    mediaHydrationPromises.set(root, hydrationPromise);
    return hydrationPromise;
  }

  function initGallery(root) {
    if (!root || root.dataset.axosGalleryReady === 'true') return;

    const gallery = getGalleryElements(root);
    const thumbs = gallery.thumbs || [];
    const mainImage = gallery.mainImage;
    const previousButton = gallery.previousButton;
    const nextButton = gallery.nextButton;
    const counter = gallery.counter;

    if (!mainImage || !previousButton || !nextButton) return;
    root.dataset.axosGalleryReady = 'true';

    const thumbButtons = thumbs.map((thumb) => thumb.closest('button') || thumb);
    const items = thumbs.map((thumb) => ({
      src: normalizeImageUrl(getImageSource(thumb)),
      alt: mainImage.alt || 'Product image'
    }));
    let index = Math.max(0, items.findIndex((item) => imageKey(item.src) === imageKey(getImageSource(mainImage))));

    function show(nextIndex) {
      index = (nextIndex + items.length) % items.length;
      const item = items[index];
      if (!item.src) return;

      setImageSource(mainImage, item.src);
      mainImage.alt = item.alt;
      if (counter) counter.textContent = (index + 1) + '/' + items.length;

      thumbButtons.forEach((button, itemIndex) => {
        const selected = itemIndex === index;
        button.classList.toggle('border-[#5094F4]', selected);
        button.classList.toggle('border-transparent', !selected);
        button.classList.toggle('opacity-70', !selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    previousButton.type = 'button';
    nextButton.type = 'button';
    previousButton.setAttribute('aria-label', 'Previous product image');
    nextButton.setAttribute('aria-label', 'Next product image');

    previousButton.addEventListener('click', (event) => {
      event.preventDefault();
      show(index - 1);
    });
    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      show(index + 1);
    });
    thumbButtons.forEach((button, itemIndex) => {
      button.type = 'button';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        show(itemIndex);
      });
    });

    show(index);
  }

  function getSelectedOffer(root, offers) {
    return root.querySelector('[data-hashi-offer][data-axos-selected-offer="true"]') ||
      offers.find((offer) => offer.getAttribute('aria-pressed') === 'true') ||
      offers[0];
  }

  function getSubscriptionOffer(offers) {
    return offers.find((offer) => offer.dataset.hashiSellingPlan) ||
      offers.find((offer) => /subscribe|subscription/i.test((offer.dataset.hashiLabel || offer.textContent || '').trim())) ||
      offers[0];
  }

  function markSubscriptionCtas(root, subscribeOffer) {
    if (!subscribeOffer) return [];

    const fallbackUrl = subscribeOffer.dataset.hashiFallbackUrl || subscribeOffer.getAttribute('href') || '/cart';
    const sellingPlan = subscribeOffer.dataset.hashiSellingPlan || '';

    return Array.from(root.querySelectorAll('a')).filter((link) => {
      if (link.matches('[data-hashi-checkout-button], [data-hashi-offer]')) return false;
      if (link.closest('header, footer, nav')) return false;

      const text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      const className = String(link.className || '');
      const href = link.getAttribute('href') || '';
      const isProductCta = /^Start Subscription$/i.test(text);
      const isButton = /\bbtn-(primary|dark)\b/.test(className);
      const hasSubscriptionRoute = href.indexOf('selling_plan=') >= 0;

      return (isProductCta && isButton) || hasSubscriptionRoute;
    }).map((link) => {
      link.dataset.axosSubscriptionCta = 'true';
      link.dataset.axosSellingPlan = sellingPlan;
      link.href = fallbackUrl;
      return link;
    });
  }

  function findBuyBox(root, checkoutButton) {
    const explicit = root.querySelector('#axos-buy');
    if (explicit) return explicit;

    const buyBox = checkoutButton && (
      checkoutButton.closest('.lg\\:sticky') ||
      checkoutButton.closest('[class*="sticky"]') ||
      checkoutButton.closest('form') ||
      checkoutButton.parentElement
    );
    if (buyBox && !buyBox.id) buyBox.id = 'axos-buy';
    return buyBox;
  }

  function routeProductCtasToBuyBox(root, buyBox) {
    if (!buyBox) return [];

    return Array.from(root.querySelectorAll('a[href]')).filter((link) => {
      if (link.closest('header, footer, nav, #axos-buy')) return false;
      if (link.matches('[data-hashi-checkout-button], [data-hashi-offer], [data-axos-subscription-cta="true"]')) return false;

      const text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      const className = String(link.className || '');
      const href = link.getAttribute('href') || '';

      if (/^Start Subscription$/i.test(text)) return false;
      if (/^#(benefits|ingredients|timeline|reviews|faq)$/i.test(href)) return false;

      const looksLikeCta = /\b(btn-primary|btn-dark|rounded-full|rounded-2xl)\b/.test(className);
      const checkoutRoute = /\/(cart\/|checkout|discount\/)/.test(href);
      const ctaText = /\b(Try|Shop Now|Buy Now|Add to Cart|Get Started|Start Today|Try .* Today)\b/i.test(text);

      return looksLikeCta && (checkoutRoute || ctaText);
    }).map((link) => {
      link.dataset.axosBuyBoxCta = 'true';
      link.href = '#axos-buy';
      link.addEventListener('click', (event) => {
        event.preventDefault();
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
      return link;
    });
  }

  function initOffers(root) {
    if (!root || root.dataset.axosOfferFixesReady === 'true') return;

    const offers = Array.from(root.querySelectorAll('[data-hashi-offer]'));
    const checkoutButton = root.querySelector('[data-hashi-checkout-button]');
    if (!offers.length || !checkoutButton) return;

    root.dataset.axosOfferFixesReady = 'true';
    const buyBox = findBuyBox(root, checkoutButton);

    function addOfferToCartAndCheckout(offer, triggerButton) {
      const variantId = Number(offer.dataset.hashiVariantId);
      const quantity = Number(offer.dataset.hashiQuantity || 1);
      const sellingPlan = offer.dataset.hashiSellingPlan;
      const discount = offer.dataset.hashiDiscount;
      const fallbackUrl = offer.dataset.hashiFallbackUrl || offer.getAttribute('href') || '/cart';

      if (!variantId || !quantity) {
        window.location.href = fallbackUrl;
        return;
      }

      const previousText = triggerButton.textContent;
      triggerButton.textContent = 'Adding...';
      triggerButton.setAttribute('aria-busy', 'true');

      const item = { id: variantId, quantity };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      }).then((response) => {
        if (!response.ok) throw new Error('Cart add failed');

        const checkoutPath = '/checkout';
        window.location.href = discount
          ? '/discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent(checkoutPath)
          : checkoutPath;
      }).catch(() => {
        triggerButton.textContent = previousText;
        triggerButton.removeAttribute('aria-busy');
        window.location.href = fallbackUrl;
      });
    }

    function setSelectedOffer(offer) {
      offers.forEach((item) => {
        item.dataset.axosSelectedOffer = item === offer ? 'true' : 'false';
      });
      checkoutButton.href = offer.dataset.hashiFallbackUrl || offer.getAttribute('href') || '/cart';
      checkoutButton.textContent = offer.dataset.hashiLabel || checkoutButton.textContent;
    }

    const subscribeOffer = getSubscriptionOffer(offers);
    const subscriptionCtas = markSubscriptionCtas(root, subscribeOffer);
    routeProductCtasToBuyBox(root, buyBox);

    offers.forEach((offer) => {
      offer.addEventListener('click', () => setSelectedOffer(offer), true);
    });
    setSelectedOffer(getSelectedOffer(root, offers));

    checkoutButton.addEventListener('click', async (event) => {
      const selectedOffer = getSelectedOffer(root, offers);
      if (!selectedOffer) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      await addOfferToCartAndCheckout(selectedOffer, checkoutButton);
    }, true);

    subscriptionCtas.forEach((button) => {
      button.addEventListener('click', async (event) => {
        if (!subscribeOffer) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        await addOfferToCartAndCheckout(subscribeOffer, button);
      }, true);
    });
  }

  function injectHeaderMenuStyles() {
    if (document.getElementById('axos-header-menu-fixes-style')) return;
    const style = document.createElement('style');
    style.id = 'axos-header-menu-fixes-style';
    style.textContent = `
      .axos-mobile-menu-overlay[hidden] { display: none !important; }
      .axos-mobile-menu-overlay {
        position: fixed;
        inset: 0;
        z-index: 2147483000;
        display: block;
        isolation: isolate;
      }
      .axos-mobile-menu-overlay__backdrop {
        position: absolute;
        inset: 0;
        border: 0;
        background: rgba(0, 0, 25, 0.46);
      }
      .axos-mobile-menu-overlay__panel {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        max-width: 420px;
        height: 100dvh;
        padding: max(24px, env(safe-area-inset-top)) 24px max(24px, env(safe-area-inset-bottom));
        overflow-y: auto;
        background: linear-gradient(180deg, #eaf6fe 0%, #ffffff 100%);
        box-shadow: 0 30px 90px rgba(0, 0, 25, 0.24);
        color: #000019;
      }
      .axos-mobile-menu-overlay__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 18px;
        margin-bottom: 24px;
      }
      .axos-mobile-menu-overlay__logo,
      .axos-mobile-header-logo {
        display: inline-flex !important;
        align-items: center;
        width: 132px !important;
        height: 50px !important;
        background: transparent !important;
        color: transparent !important;
        -webkit-text-fill-color: transparent !important;
        overflow: hidden !important;
        white-space: nowrap !important;
      }
      .axos-mobile-header-logo > *,
      .axos-mobile-menu-overlay__logo > * { opacity: 0 !important; visibility: hidden !important; }
      .axos-mobile-header-logo img,
      .axos-mobile-menu-overlay__logo img {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
        width: 100% !important;
        height: auto !important;
        max-height: 50px !important;
        object-fit: contain !important;
      }
      .axos-mobile-menu-overlay__close {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        border: 1px solid rgba(0, 0, 25, 0.12);
        border-radius: 999px;
        background: #fff;
        color: #000019;
        font-size: 24px;
        line-height: 1;
      }
      .axos-mobile-menu-overlay__nav {
        display: grid;
        gap: 12px;
      }
      .axos-mobile-menu-overlay__nav a {
        display: flex;
        align-items: center;
        min-height: 48px;
        padding: 0 16px;
        border: 1px solid rgba(80, 148, 244, 0.22);
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.82);
        color: #000019;
        font-weight: 700;
        text-decoration: none;
      }
      .axos-mobile-menu-open,
      .axos-mobile-menu-open body { overflow: hidden !important; }
      .axos-mobile-injected-header { display: none; }
      @media (max-width: 767px) {
        .axos-mobile-injected-header { display: block; position: sticky; top: 0; z-index: 50; background: #fff; border-bottom: 1px solid rgba(0,0,25,.06); }
        .axos-mobile-injected-header__promo { min-height: 36px; display: flex; align-items: center; justify-content: center; padding: 8px 14px; background: linear-gradient(105deg, #09c9e9 0%, #5094f4 52%, #7874f8 100%); color: #fff; font-size: 11px; font-weight: 800; letter-spacing: .06em; text-align: center; text-transform: uppercase; line-height: 1.25; }
        .axos-mobile-injected-header__bar { min-height: 68px; display: flex; align-items: center; justify-content: space-between; padding: 0 16px; background: rgba(255,255,255,.96); backdrop-filter: blur(12px); }
        .axos-mobile-injected-header__actions { display: inline-flex; align-items: center; gap: 10px; }
        .axos-mobile-injected-header__icon { display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; border: 0; border-radius: 999px; background: transparent; color: #000019; }
        .axos-mobile-injected-header__icon svg { width: 22px; height: 22px; }
        header .axos-mobile-header-logo { flex: 0 0 auto !important; }
        header button[aria-label='Menu'], header button[aria-label='Open menu'] { cursor: pointer; }
      }
    `;
    document.head.appendChild(style);
  }

  function normalizeHeaderLogo(header) {
    if (!header || header.dataset.axosLogoNormalized === 'true') return;
    const logoLink = Array.from(header.querySelectorAll('a[href="/"], a[href="' + window.location.origin + '/"], a[aria-label*="AXOS" i]')).find((link) => {
      return /axos/i.test(link.textContent || link.getAttribute('aria-label') || '') || link.querySelector('img[alt*="AXOS" i]');
    }) || Array.from(header.querySelectorAll('a')).find((link) => /axos/i.test(link.textContent || ''));
    if (!logoLink) return;
    logoLink.classList.add('axos-mobile-header-logo');
    logoLink.setAttribute('aria-label', 'AXOS home');
    if (!logoLink.querySelector('img[alt*="AXOS" i]')) {
      logoLink.innerHTML = '<img src="' + AXOS_LOGO_URL + '" alt="AXOS" loading="eager">';
    }
    header.dataset.axosLogoNormalized = 'true';
  }

  function menuLinksFor(header) {
    const links = [
      { href: '/', label: 'Home' },
      { href: '/collections/all', label: 'Shop All' },
      { href: '/products/axos-system', label: 'Axos System' },
      { href: '/products/hashiaid', label: 'HashiAid' },
      { href: '/products/ibdassist', label: 'GUTsupport' }
    ];
    const seen = new Set(links.map((item) => item.href + '|' + item.label));
    [
      { href: '/blogs/news', label: 'Blogs' },
      { href: '/account/login', label: 'Customer Login' },
      { href: '/cart', label: 'Cart' }
    ].forEach((item) => {
      const key = item.href + '|' + item.label;
      if (!seen.has(key)) links.push(item);
    });
    return links;
  }

  function getOrCreateMobileMenu(header) {
    let menu = document.getElementById('axos-global-mobile-menu');
    if (!menu) {
      menu = document.createElement('div');
      menu.id = 'axos-global-mobile-menu';
      menu.className = 'axos-mobile-menu-overlay';
      menu.hidden = true;
      menu.setAttribute('role', 'dialog');
      menu.setAttribute('aria-modal', 'true');
      menu.setAttribute('aria-label', 'AXOS navigation');
      document.body.appendChild(menu);
    }
    const links = menuLinksFor(header);
    menu.innerHTML = '<button type="button" class="axos-mobile-menu-overlay__backdrop" data-axos-menu-close aria-label="Close menu"></button>' +
      '<aside class="axos-mobile-menu-overlay__panel">' +
        '<div class="axos-mobile-menu-overlay__top">' +
          '<a href="/" class="axos-mobile-menu-overlay__logo" aria-label="AXOS home"><img src="' + AXOS_LOGO_URL + '" alt="AXOS" loading="eager"></a>' +
          '<button type="button" class="axos-mobile-menu-overlay__close" data-axos-menu-close aria-label="Close menu">×</button>' +
        '</div>' +
        '<nav class="axos-mobile-menu-overlay__nav">' +
          links.map((item) => '<a href="' + item.href + '">' + item.label + '</a>').join('') +
        '</nav>' +
      '</aside>';
    menu.querySelectorAll('[data-axos-menu-close]').forEach((button) => {
      button.addEventListener('click', closeMobileMenu);
    });
    menu.querySelectorAll('a[href]').forEach((link) => {
      link.addEventListener('click', () => setTimeout(closeMobileMenu, 0));
    });
    return menu;
  }

  function openMobileMenu(header) {
    const menu = getOrCreateMobileMenu(header);
    menu.hidden = false;
    document.documentElement.classList.add('axos-mobile-menu-open');
  }

  function closeMobileMenu() {
    const menu = document.getElementById('axos-global-mobile-menu');
    if (menu) menu.hidden = true;
    document.documentElement.classList.remove('axos-mobile-menu-open');
  }

  function initHeaderMenuForHeader(header) {
    if (!header || header.dataset.axosMenuFixed === 'true') return;
    normalizeHeaderLogo(header);
    const menuButton = Array.from(header.querySelectorAll('button, a')).find((node) => {
      return /\bMenu\b|Open menu/i.test(node.getAttribute('aria-label') || node.textContent || '') || String(node.className || '').includes('lg:hidden');
    });
    if (!menuButton) return;
    menuButton.dataset.axosMenuTrigger = 'true';
    menuButton.setAttribute('type', 'button');
    menuButton.setAttribute('aria-label', 'Open menu');
    menuButton.setAttribute('aria-haspopup', 'dialog');
    menuButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openMobileMenu(header);
    }, true);
    header.dataset.axosMenuFixed = 'true';
  }

  function ensureBlogMobileHeader() {
    if (!/^\/blogs\b/.test(window.location.pathname)) return;
    const visibleHeader = Array.from(document.querySelectorAll('header')).find((header) => {
      const rect = header.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0;
    });
    if (visibleHeader || document.querySelector('.axos-mobile-injected-header')) return;
    const header = document.createElement('header');
    header.className = 'axos-mobile-injected-header';
    header.innerHTML = '<div class="axos-mobile-injected-header__promo">Free Shipping $79+ · Subscriptions ship free · 90-day money-back guarantee</div>' +
      '<div class="axos-mobile-injected-header__bar">' +
        '<a href="/" class="axos-mobile-header-logo" aria-label="AXOS home"><img src="' + AXOS_LOGO_URL + '" alt="AXOS" loading="eager"></a>' +
        '<div class="axos-mobile-injected-header__actions">' +
          '<a href="/cart" class="axos-mobile-injected-header__icon" aria-label="Cart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg></a>' +
          '<button type="button" class="axos-mobile-injected-header__icon" aria-label="Open menu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6h16"></path><path d="M4 12h16"></path><path d="M4 18h16"></path></svg></button>' +
        '</div>' +
      '</div>';
    const main = document.getElementById('MainContent') || document.body.firstElementChild;
    document.body.insertBefore(header, main);
    initHeaderMenuForHeader(header);
  }

  function initHeaderMenus() {
    injectHeaderMenuStyles();
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      initHeaderMenuForHeader(root.querySelector('header'));
    });
    ensureBlogMobileHeader();
  }

  function init() {
    initHeaderMenus();
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      hydrateGalleryFromProduct(root).finally(() => initGallery(root));
      initOffers(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 250);
  setTimeout(init, 1000);
})();

